import classNames from 'classnames';
import { forwardRef } from 'react';
import FlexContainer from '../FlexContainer';
import styles from './ContentBlock.module.scss';

/**
 * ContentBlock
 *
 * @return {JSX.Element}
 */
const ContentBlock = (
  {
    className,
    noPadding,
    overflowHidden,
    green,
    black,
    blue,
    grey,
    square,
    red,
    yellow,
    transparent,
    ...rest
  },
  ref
) => {
  return (
    <FlexContainer
      ref={ref}
      className={classNames(
        styles.ContentBlock,
        noPadding && styles.ContentBlock__noPadding,
        overflowHidden && styles.ContentBlock__overflowHidden,
        green && styles.ContentBlock__green,
        red && styles.ContentBlock__red,
        yellow && styles.ContentBlock__yellow,
        black && styles.ContentBlock__black,
        grey && styles.ContentBlock__grey,
        blue && styles.ContentBlock__blue,
        square && styles.ContentBlock__square,
        transparent && styles.ContentBlock__transparent,
        className,
        `${ContentBlock.displayName}`
      )}
      maxWidth100
      {...rest}
    />
  );
};
// const ContentBlock = ({
//   className,
//   noPadding,
//   overflowHidden,
//   displayFlex,
//   column,
//   ...rest
// }) => {
//   return (
//     <View
//       className={classNames(
//         styles.ContentBlock,
//         noPadding && styles.ContentBlock__noPadding,
//         overflowHidden && styles.ContentBlock__overflowHidden,
//         displayFlex && styles.ContentBlock__displayFlex,
//         column && styles.ContentBlock__column,
//         className,
//         `${ContentBlock.displayName}`
//       )}
//       {...rest}
//     />
//   );
// };

ContentBlock.displayName = 'ContentBlock';

export default forwardRef(ContentBlock);
